/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	FancyTicketAction,
	TicketActionTypes,
	TicketChangedToEditAction,
	TicketLiveUpdateAction,
	TicketPersistData,
} from 'src/app/app-data/actions/ticket-actions';
import { TicketFields } from '@touchplan/common';
import { TicketList } from 'src/app/common/fancy-firebase-ticket/lists/TicketList';

/**
 * Much of the stuff in this file is wholesale duplicated and/or roughly modified versions of stuff from ticket-action-builders.
 * Little to no effort has been put into refactoring the old stuff as the "correct" thing at this point would be to port TicketList to
 * be a proper SplitData thing and use that whole thing. Since we'll do that _eventually_ there's little value in making the old stuff too...
 * "fancy"
 */

/**
 * Creates the action from passed in data
 * @param payload Can be basically anything, and is disambiguated within ticketList by the various interfaces.
 * Most technically correct thing would be to define with the union of every thing in CombinedTicketActions.payload
 * @param config Can be basically anything, and is disambiguated within ticketList by the various interfaces
 */
function writeTicketAction(
	ticketId: string,
	payload: any,
	actionType: TicketActionTypes,
	ticketList: TicketList,
	config?: any
) {
	const action = new FancyTicketAction(payload, actionType, ticketId, config);
	ticketList.appEvent$.next(action);
}

/** Modify local ticket data, applies your passed in data to both the selected renderType and the view. */
export function updateTicketLiveData(
	ticketId: string,
	updateData: TicketFields,
	ticketList: TicketList,
	config?: TicketLiveUpdateAction['config']
) {
	const actionType = TicketActionTypes.ticketLiveUpdate;
	writeTicketAction(ticketId, updateData, actionType, ticketList, config);
}

/** (emits with a special edit type) Modify local ticket data, applies your passed in data to both the selected renderType and the view. */
export function updateTicketEditData(
	ticketId: string,
	updateData: TicketFields,
	ticketList: TicketList,
	config?: TicketLiveUpdateAction['config']
) {
	const actionType = TicketActionTypes.ticketEditUpdate;
	writeTicketAction(ticketId, updateData, actionType, ticketList, config);
}

/** Change the passed in ticket(s) to edit view */
export function changeTicketViewToEdit(ticketId: string, ticketList: TicketList) {
	const actionType = TicketActionTypes.ticketChangedToEdit;
	const ticket = ticketList.syncList.get(ticketId);
	writeTicketAction(ticketId, ticket, actionType, ticketList);
}

/** Change the passed in ticket(s) to default view */
export function changeTicketViewToDefault(ticketId: string, ticketList: TicketList) {
	const actionType = TicketActionTypes.ticketChangedToDefault;
	const ticket = ticketList.syncList.get(ticketId);
	writeTicketAction(ticketId, ticket, actionType, ticketList);
}

/** Reset the ticket back it's databaseData */
export function changeTicketViewDataToDatabase(ticketId: string, ticketList: TicketList) {
	const actionType = TicketActionTypes.ticketViewDataResetToDatabase;
	const ticket = ticketList.syncList.get(ticketId);
	writeTicketAction(ticketId, ticket, actionType, ticketList);
}

/** persists to firebase */
export function persistTicketData(
	ticketId: string,
	ticketList: TicketList,
	config?: TicketPersistData['config']
) {
	const actionType = TicketActionTypes.ticketPersistData;
	const ticket = ticketList.syncList.get(ticketId);
	writeTicketAction(ticketId, ticket, actionType, ticketList, config);
}
